import { OnInit, EventEmitter } from '@angular/core';
import { AssetService } from 'app/library-assets/services/asset.service';
var AssetPickerComponent = /** @class */ (function () {
    function AssetPickerComponent(assetService) {
        this.assetService = assetService;
        this.selected = new EventEmitter();
    }
    AssetPickerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.hasLoaded = false;
        this.loadFailed = false;
        var loaders = [];
        this.tags = [{ label: "Filter by tag...", value: "" }, { label: "All", value: "All" }];
        Promise.all([this.assetService.getAssets(), this.assetService.getTags()])
            .then(function (results) {
            var assets = results[0], tags = results[1];
            _this.hasLoaded = true;
            _this._assets = assets;
            tags.forEach(function (t) { return _this.tags.push({ label: t, value: t }); });
        })
            .catch(function (error) {
            _this.loadFailed = true;
            _this.hasLoaded = true;
            console.error(error);
        });
    };
    Object.defineProperty(AssetPickerComponent.prototype, "Assets", {
        get: function () {
            return this._assets;
        },
        enumerable: true,
        configurable: true
    });
    AssetPickerComponent.prototype.searchTitle = function (title) {
        this.assetSearch = title.trim();
        this.runSearch();
    };
    AssetPickerComponent.prototype.searchTag = function (tag) {
        var _this = this;
        if (!tag) {
            this.selectedTag = null;
        }
        else {
            this.selectedTag = tag;
        }
        // we seem to be having a timing issue here on select boxes.
        setTimeout(function () {
            _this.runSearch();
        }, 100);
    };
    AssetPickerComponent.prototype.searchType = function (type) {
        var _this = this;
        this.assetType = type;
        // we seem to be having a timing issue here on select boxes.
        setTimeout(function () {
            _this.runSearch();
        }, 100); // there is a major timing i
        // this.runSearch();
    };
    AssetPickerComponent.prototype.runSearch = function () {
        var _this = this;
        this.assetService.searchAssets(this.assetSearch, this.selectedTag, this.assetType)
            .then(function (assets) {
            _this._assets = [];
            assets.forEach(function (a) {
                _this._assets.push(a);
            });
            // this._assets = assets;
        });
    };
    AssetPickerComponent.prototype.getRouterLink = function (asset) {
        if (asset.type == 'article') {
            return ['/admin/library/articles/' + asset.id];
        }
        else {
            return ['/admin/library/exercises/' + asset.id];
        }
    };
    AssetPickerComponent.prototype.pick = function (asset) {
        console.log("selecting ", asset);
        this.selected.emit(asset);
    };
    return AssetPickerComponent;
}());
export { AssetPickerComponent };



// WEBPACK FOOTER //
// ./src/app/library-assets/asset-picker/asset-picker.component.ts.pre-build-optimizer.js